<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="entry.manufacturingLotId"
          v-bind="getObject('manufacturingLotId')"
          label="Lote"
          :items="this.lotItemsList"
          @input="changeSelectedItem"          
          item-value="id"
          item-text="name"
          :disabled="readOnly"
          autocomplete="off"
        >
        <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-1">{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>
                Qtd. disponível: {{data.item.formatedAvailableQuantity}} {{data.item.unitName}} - Qtd. de emb.: {{data.item.packagingQuantity}} {{data.item.packagingName}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"      
          @update:inputData="changePackagingQuantity"
          autocomplete="off"
          :disabled="readOnly"
          :suffix="packaging ? packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />
        <!--   -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"          
          @update:inputData="changeQuantity"
          :hint="quantityHint"
          persistent-hint
          autocomplete="off"
          :disabled="readOnly"
          :suffix="itemSelected ? itemSelected.unitName : ''"
          :key="quantityKey + 'quantity'"
        />
        <!-- -->
      </v-col>
     
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},      
      lotItemsList: [],
      renderComponent: true,
      itemsSearch: "",
      unitPriceKey: 0,
      totalPriceKey: 0,
      packagingQuantityKey: 0,
      quantityKey: 0,
      packagingPriceKey: 0,
      pageLoading: false,
      itemSelected: {},
      interizator: 10000000000.0,
    };
  },
  props: {
    entry: Object,
    originalEntry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    packaging: Object,
    itemLots: {
      type: Array,
      default: new Array(),
    },
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {    
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("item purchase", this.entry.item)
    if (this.entry.itemLotAttributes) {
      // this.purchaseItemsList = [this.entry.item];
      // this.selectItem(false);
      this.changeQuantity();
    }
    this.loadItemLots();
  },
  mounted() {
  },
  computed: {    
    quantityHint: function() {
      // console.log(this.itemSelected);
      var availableQuantity =  parseFloat(this.itemSelected?.availableQuantity);
      if(this.isEdit){
        availableQuantity += this.originalEntry.quantity;
      }
      return (this.entry.manufacturingLotId && this.itemSelected) ? "Quantidade disponível: " + availableQuantity + " " + this.itemSelected.unitName : null
    }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      // if (this.itemsSearch && this.itemsSearch.length > 0) {
      //   if (!this.entry.item || this.entry.item.name != this.itemsSearch) {
      //     this.getPurchaseItems();
      //   }
      // }
    }
  },
  methods: {
    loadItemLots: function(){
      for(var i=0;i<this.itemLots.length; i++){
        this.lotItemsList.push(this.itemLots[i]);
      }
      // console.log("lotList", this.lotItemsList);
      this.changeSelectedItem();
    },
    changeSelectedItem: function(){
      this.itemSelected = this.lotItemsList.find(obj => obj.id == this.entry.manufacturingLotId);
      // console.log("entry change selected item", this.entry);
      // this.entry.manufacturingLotId = 12;
      if(this.itemSelected){
        // console.log("item", this.itemSelected);
        this.entryAttributes.quantity.rules = []
        var availableQuantity =  parseFloat(this.itemSelected.availableQuantity);
        if(this.isEdit){
          availableQuantity += this.originalEntry.quantity;
        }
        this.entryAttributes.quantity.rules.push(this.maxValueRule(availableQuantity));
        this.setItemLot(this.itemSelected);
      }
    },
    changeQuantity: function() {
      this.entry.packagingQuantity = _.round(this.entry.quantity / this.packaging.size, 10);
      this.packagingQuantityKey++;
      // this.updateQuantity();
    },
    // updateQuantity: function() {
    //   if (this.entry.unitPrice > 0) {
    //     this.calculatePackagingPrice();
    //     this.calculateTotalPrice();
    //   } else if (this.entry.price > 0) {
    //     this.calculateUnitPrice();
    //     this.calculatePackagingPrice();
    //   } else {
    //     this.entry.price = 0;
    //     this.totalPriceKey++;
    //     this.entry.unitPrice = 0;
    //     this.unitPriceKey++;
    //     this.entry.packagingPrice = 0;
    //     this.packagingPriceKey++;
    //   }
    // },
    // changePackagingQuantity: function() {
    //   this.entry.quantity = _.round(this.packagingQuantity * this.packaging.size, 10);
    //   this.quantityKey++;
    //   // this.updateQuantity();
    // },
    changePackagingQuantity: function() {
      // console.log("pk size",this.entry.packagingQuantity);
      var temp = (Math.floor(this.entry.packagingQuantity * this.interizator) * this.packaging.size) / this.interizator;
      // console.log("temp", temp);
      this.entry.quantity = _.round(temp, 10);
      // this.entry.quantity = _.round(this.entry.packagingQuantity * this.packaging.size, 10);
      this.quantityKey++;
    },
    // changeUnitPrice: function() {
    //   if (this.entry.quantity > 0) {
    //     this.calculatePackagingPrice();
    //     this.calculateTotalPrice();
    //   }
    // },
    // changePackagingPrice: function() {
    //   if (this.entry.quantity > 0) {
    //     this.calculateUnitPrice(false);
    //     this.calculateTotalPrice();
    //   }
    // },
    // changeTotalPrice: function() {
    //   if (this.entry.quantity > 0) {
    //     this.calculateUnitPrice();
    //     this.calculatePackagingPrice();
    //   }
    // },
    // calculateTotalPrice: function() {
    //   this.entry.price = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
    //   this.totalPriceKey++;
    // },
    // calculateUnitPrice: function(byTotalPrice=true) {
    //   if (byTotalPrice) {
    //     this.entry.unitPrice = _.round((this.entry.price ? this.entry.price : 0) / (this.entry.quantity ? this.entry.quantity : 0), 10);
    //   } else { //calcula pelo preco unitario com base no preco da embalagem
    //     this.entry.unitPrice = _.round((this.entry.packagingPrice ? this.entry.packagingPrice : 0) / (this.packaging.size ? this.packaging.size : 0), 10);
    //   }
    //   this.unitPriceKey++;
    // },
    // calculatePackagingPrice: function() {
    //   this.entry.packagingPrice = _.round((this.entry.unitPrice ? this.entry.unitPrice : 0) * (this.packaging.size ? this.packaging.size : 0), 10);
    //   this.packagingPriceKey++;
    // },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },    
    clearFields: function() {
      this.forceRerender(this);
    },
    packagingCreated: function(packaging) {
      // this.selectItem(true, packaging);
    },
    storageCreated: function(storage) {
      this.extraData.accountContext.allStorages.unshift(storage);
      this.entry.storageId = storage.id;
      this.entry.storage = storage;
    },
    setItemLot: function(itemLot){
      // console.log("itemloooot", itemLot);      
      if(itemLot){
        this.entry.name = itemLot.name;
        this.entry.lotNumber = itemLot.lotNumber;
        this.entry.manufacturingDate = itemLot.manufacturingDate;
        this.entry.dueDate = itemLot.dueDate;
        this.entry.availableQuantity = itemLot.availableQuantity;
        this.entry.unitName = itemLot.unitName;
        this.entry.quantity = itemLot.quantity;                
      }
    },
    itemCreated: function(item) {
      this.lotItemsList.unshift(item);
      this.entry.manufacturingLotId = item.id;      
      item.quantity = this.quantity;
      item.packagingQuantity = this.packagingQuantity;
      this.setItemLot(item);
    },
  }
};

const ITEMS_FOR_PURCHASE_QUERY = gql `
  query ($query: String!) {
    accountGlobalSharedContext {
      allAvailableItemsForPurchase(query: $query) {
        id
        name
        unit {
          name
        }
        brand {
          name
        }
        typeText
      }
    }
  }
`;

const PACKAGINGS_FOR_ITEM_QUERY = gql `
  query ($itemId: ID!) {
    accountGlobalSharedContext {
      allPackagingsOfItem(itemId: $itemId) {
        id
        name
        unitName
        size
        text
      }
    }
  }
`;

const LOAD_ALL_ITEM_LOTS = gql `
  query {
    accountContext {
      allItemLots {
        id
        lotNumber        
        manufacturingDate
        dueDate
      }
    }
  }
`;



</script>

<style scoped></style>
